import { Vertex } from './entity';
import { Edge } from './edge';

export interface J1QL_queryV1 {
  type: string;
  cursor?: string | null;
  totalCount?: number | null;
}

export interface J1QLTreeData extends J1QL_queryV1 {
  data?: {
    vertices: Vertex[];
    edges: Edge[];
  };
}

export interface J1QLListData extends J1QL_queryV1 {
  data?: Vertex[];
}

export type J1QLResultData = J1QLTreeData | J1QLListData;

export interface J1QL {
  queryV1: J1QLResultData;
}

export interface QueryV1Flags {
  allPages?: boolean;
  rowMetadata?: boolean;
  computedProperties?: boolean;
}

export enum DeferredResponseFormat {
  JSON = 'JSON',
  CSV = 'CSV',
}

export interface QueryV1Input {
  query: string;
  remember?: boolean;
  includeDeleted?: boolean;
  deferredFormat?: DeferredResponseFormat;
  flags?: QueryV1Flags;
  cursor?: string;
}

export type DeferredQueryInput = QueryV1Input & {
  variables?: Record<string, string | number | boolean>;
};

export interface DeferredQueryResponse {
  url: string;
}

export const isJ1QLTreeData = (
  input: J1QLResultData
): input is J1QLTreeData => {
  return (input as J1QLTreeData).data?.edges !== undefined;
};

export const isJ1QLListData = (
  input: J1QLResultData
): input is J1QLListData => {
  return (input as J1QLListData).data?.length !== undefined;
};
